/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heating_Curve_Copy_WarningInputs */



/**
* | output |
* | --- |
* | "Points already present in the selected networks will be deleted" |
*
* @param {Heating_Curve_Copy_WarningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_curve_copy_warning = /** @type {((inputs?: Heating_Curve_Copy_WarningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Curve_Copy_WarningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Points already present in the selected networks will be deleted")
	return /** @type {LocalizedString} */ ("Les points déjà présents dans les réseaux sélectionnés seront supprimés")
});